import { render, staticRenderFns } from "./annotation-toggle.vue?vue&type=template&id=54c539ce&"
import script from "./annotation-toggle.vue?vue&type=script&lang=js&"
export * from "./annotation-toggle.vue?vue&type=script&lang=js&"
import style0 from "./annotation-toggle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports